/* unplugin-vue-components disabled */import { ElInput as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import { ElDropdown as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dropdown/style/css';
import { ElDropdownMenu as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dropdown-menu/style/css';
import { ElDropdownItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dropdown-item/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue";
import _imports_0 from '../assets/img/search.png';
import _imports_1 from '../assets/img/wx.png';
import _imports_2 from '../assets/img/gzh.jpg';
var _hoisted_1 = {
  "class": "header-content"
};
var _hoisted_2 = {
  "class": "wrap"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  key: 1,
  "class": "dropdown"
};
var _hoisted_5 = ["textContent"];
import store from '@/store';
import eventBus from '../event/mitt';
export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderViews',
  setup: function setup(__props) {
    var router = useRouter();
    function login() {
      router.push("/login");
    }
    var searchName = ref('');
    function clearKey() {
      router.push('/');
    }
    function search1() {
      // if(!searchName.value){
      //     ElMessage.error('请输入搜索内容')
      //     return
      // }
      eventBus.emit('searchName', searchName.value);
      router.push({
        path: 'searchTitle',
        query: {
          keyName: searchName.value
        }
      });
    }
    function reg() {
      router.push("/reg");
    }
    var isLogin = ref(false);
    var email = ref('');
    eventBus.on("isLogin", function (data) {
      isLogin.value = data;
    });
    eventBus.on("memberEmail", function (data) {
      isLogin.value = true;
      email.value = data;
    });
    // eventBus.on("memberInfo", (data: any) => {
    //     memberInfoData.value = cloneDeep(data)
    // })
    // onMounted(async () => {
    //     if (store.getters.getToken) {
    //         const response = await memberInfoApi()
    //         if (response.code === -1 || response.code === -2 || response.code === -3 || response.code === -4 || response.code === -5) {
    //             isLogin.value = false
    //         } else {
    //             isLogin.value = true
    //         }
    //     } else {
    //         isLogin.value = false
    //         router.push("/")
    //     } 
    // })
    function info() {
      router.push("/info");
    }
    function logout() {
      store.commit('REMOVE_TOKEN');
      isLogin.value = false;
      router.push("/login");
    }
    return function (_ctx, _cache) {
      var _component_el_dropdown_item = __unplugin_components_0;
      var _component_el_dropdown_menu = __unplugin_components_1;
      var _component_el_dropdown = __unplugin_components_2;
      var _component_el_input = __unplugin_components_3;
      return _openBlock(), _createElementBlock("header", null, [_createElementVNode("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("span", null, "IIFA国际投资理财协会", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
        "class": "zs_search",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _unref(router).push('/search');
        })
      }, "证书查询"), _createElementVNode("ul", null, [!_unref(isLogin) ? (_openBlock(), _createElementBlock("li", _hoisted_3, [_createElementVNode("span", {
        onClick: login
      }, "登录"), _cache[2] || (_cache[2] = _createElementVNode("span", {
        "class": "margin5p_lr"
      }, "|", -1)), _createElementVNode("span", {
        onClick: reg
      }, "注册")])) : _createCommentVNode("", true), _unref(isLogin) ? (_openBlock(), _createElementBlock("li", _hoisted_4, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(function () {
          return [_createVNode(_component_el_dropdown_menu, {
            style: {
              "width": "200px",
              "background-color": "#f9f9f9"
            }
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                style: {
                  "font-size": "16px",
                  "text-align": "center"
                },
                onClick: info
              }, {
                "default": _withCtx(function () {
                  return _cache[3] || (_cache[3] = [_createTextVNode("个人中心")]);
                }),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                style: {
                  "font-size": "16px",
                  "text-align": "center"
                },
                onClick: logout
              }, {
                "default": _withCtx(function () {
                  return _cache[4] || (_cache[4] = [_createTextVNode("退出登录")]);
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        "default": _withCtx(function () {
          return [_createElementVNode("span", {
            "class": "el-dropdown-link",
            textContent: _toDisplayString(_unref(email))
          }, null, 8, _hoisted_5)];
        }),
        _: 1
      })])) : _createCommentVNode("", true), _cache[7] || (_cache[7] = _createElementVNode("li", null, null, -1)), _createVNode(_component_el_input, {
        modelValue: _unref(searchName),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(searchName) ? searchName.value = $event : null;
        }),
        placeholder: "请输入搜索关键词",
        clearable: "",
        onClear: clearKey,
        style: {
          "height": "40px",
          "width": "170px"
        }
      }, {
        prefix: _withCtx(function () {
          return [_createElementVNode("img", {
            src: _imports_0,
            style: {
              "width": "25px",
              "cursor": "pointer"
            },
            onClick: search1,
            alt: "",
            srcset: ""
          })];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("li", null, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(function () {
          return [_createVNode(_component_el_dropdown_menu, null, {
            "default": _withCtx(function () {
              return _cache[5] || (_cache[5] = [_createElementVNode("img", {
                src: _imports_2,
                style: {
                  "width": "180px",
                  "height": "180px"
                },
                "class": "image",
                alt: "",
                srcset: ""
              }, null, -1)]);
            }),
            _: 1
          })];
        }),
        "default": _withCtx(function () {
          return [_cache[6] || (_cache[6] = _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            srcset: ""
          }, null, -1))];
        }),
        _: 1
      })])])])])]);
    };
  }
});